/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Theme_TitleInputs */

const cs_builder_theme_title = /** @type {(inputs: Builder_Theme_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barvy motivu`)
};

const en_builder_theme_title = /** @type {(inputs: Builder_Theme_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme colors`)
};

/**
* | output |
* | --- |
* | "Theme colors" |
*
* @param {Builder_Theme_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_theme_title = /** @type {((inputs?: Builder_Theme_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Theme_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_theme_title(inputs)
	return cs_builder_theme_title(inputs)
});